// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"231":"df9ad02b","824":"7e2c1ad7","852":"c55583b2","971":"ae9cfd6a"}[chunkId] + ".chunk.js";
};